
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/lcl-faq-german-language-school",
      function () {
        return require("private-next-pages/en/lcl-faq-german-language-school/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/lcl-faq-german-language-school"])
      });
    }
  